import { createConfig, http } from "wagmi";
import { polygon, mainnet } from "wagmi/chains";
import { QueryClient } from "@tanstack/react-query";

import memoriesArtifacts from "good-death-contracts/artifacts/contracts/Memoryforms.sol/Memoryforms.json";
import charonArtifacts from "good-death-contracts/artifacts/contracts/Charon.sol/Charon.json";
import goodDeathArtifacts from "good-death-contracts/artifacts/contracts/GoodDeath.sol/GoodDeath.json";
import lifeformsArtifacts from "lifeforms-contracts/build/contracts/Lifeforms2.json";

export const config = createConfig({
    // Your dApps chains
    chains: [mainnet, polygon],
    transports: {
    // RPC URL for each chain
    [mainnet.id]: http(
        `${process.env.REACT_APP_ETHEREUM_NODE_ENDPOINT}`,
    ),
    [polygon.id]: http(
        `${process.env.REACT_APP_POLYGON_NODE_ENDPOINT}`,
    ),
    },

    // Required API Keys
    walletConnectProjectId: process.env.REACT_APP_WALLETCONNECT_ID,

    // Required App Info
    appName: "good death",

    // Optional App Info
    // appDescription: "Your App Description",
    // appUrl: "https://family.co", // your app's url
    // appIcon: "https://family.co/logo.png", // your app's icon, no bigger than 1024x1024px (max. 1MB)
});

export const queryClient = new QueryClient();

export const MemoriesConfig = {
    address: process.env.REACT_APP_MEMORIES_ADDRESS,
    abi: memoriesArtifacts.abi,
    chainId: 1
}

export const LifeformsConfig = {
    address: process.env.REACT_APP_LIFEFORMS_ADDRESS,
    abi: lifeformsArtifacts.abi,
    chainId: 137
}

export const CharonConfig = {
    address: process.env.REACT_APP_CHARON_ADDRESS,
    abi: charonArtifacts.abi,
    chainId: 137
}

export const GoodDeathConfig = {
    address: process.env.REACT_APP_DEATHFORMS_ADDRESS,
    abi: goodDeathArtifacts.abi,
    chainId: 1
}